import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import * as am5 from '@amcharts/amcharts5'
import * as am5xy from '@amcharts/amcharts5/xy'
import * as am5percent from "@amcharts/amcharts5/percent"
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faUser, faEye, faEyeSlash, faSpinner, faChevronRight, faBars, faCaretUp, faCaretDown, faSquare, faTimes, faTimesCircle, faCalendar, faInfoCircle, faBan, faHourglass, faBell, faBug, faCheck, faTrash, faClone, faPlus, faMinus, faEdit, faShoppingCart } from '@fortawesome/free-solid-svg-icons'
library.add(faUser, faEye, faEyeSlash, faSpinner, faChevronRight, faBars, faCaretUp, faCaretDown, faSquare, faTimes, faTimesCircle, faCalendar, faInfoCircle, faBan, faHourglass, faBell, faBug, faCheck, faTrash, faClone, faPlus, faMinus, faEdit, faShoppingCart)
Vue.component('font-awesome-icon', FontAwesomeIcon)

import Filters from '@/components/Filters.vue'
Vue.component('filters', Filters)

import Pagination from '@/components/Pagination.vue'
Vue.component('pagination', Pagination)

import MessageModal from '@/components/MessageModal.vue'
Vue.component('message-modal', MessageModal)

import AddToCart from '@/components/AddToCart.vue'
Vue.component('add-to-cart', AddToCart)

import Product from '@/components/Product.vue'
Vue.component('product', Product)

import Dealer from '@/components/Dealer.vue'
Vue.component('dealer', Dealer)

import "./styles/styles.scss";

Vue.config.productionTip = false

Vue.mixin({
    methods: {
        getToday() {
            let date = new Date()
            return date.getFullYear() + '-' + String(date.getMonth()+1).padStart(2, '0') + '-' + String(date.getDate()).padStart(2, '0')
        },
        getYesterday() {
            let today = new Date()
            let yesterday = new Date(today)
            return yesterday.setDate(yesterday.getDate() - 1)
        },
        getThisMonth() {
            let date = new Date()
            if (date.getMonth() === 0 && date.getDate() === 1) {
                let yesterday = new Date(date)
                yesterday.setDate(yesterday.getDate() - 1)
                return String(yesterday.getMonth()+1).padStart(2, '0')
            } else {
                return String(date.getMonth()+1).padStart(2, '0')
            }
        },
        getThisQuarter() {
            let date = new Date()
            if (date.getMonth() === 0 && date.getDate() === 1) {
                let yesterday = new Date(date)
                yesterday.setDate(yesterday.getDate() - 1)
                return Math.ceil((yesterday.getMonth()+1) / 3)
            } else {
                return Math.ceil((date.getMonth()+1) / 3)
            }
        },
        getThisYear() {
            let date = new Date()
            if (date.getMonth() === 0 && date.getDate() === 1) {
                return date.getFullYear() - 1
            } else {
                return date.getFullYear()
            }
        },
		capitalizeWords(rawString) {
			if (!rawString) return
			return rawString.toLowerCase().replace('_',' ').replace(/\b\w/g, l => l.toUpperCase())
		},
        formatDate(dateString) {
            if (!dateString) return
            let dateTimeParts = dateString.split(' ')
            let dateParts = dateTimeParts[0].split('-')
            let niceDate = ''
            switch (dateParts.length) {
                case 3:
                    niceDate = dateParts[1].padStart(2, '0') + '/' + dateParts[2].padStart(2, '0') + '/' + dateParts[0]
                    break
                case 2:
                    niceDate = dateParts[1].padStart(2, '0') + '/' + dateParts[2].padStart(2, '0')
                    break
                case 1:
                    niceDate = dateString
                    break
            }
            return niceDate
        },
        formatCurrency(price) {
            if (!price) return
            price = price.toString()
            if (price.indexOf('.') > -1) {
                var parts = price.split('.')
            } else {
                var parts = [price]
            }
            var leftOfDecimal = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            var rightOfDecimal = parts[1] ? parts[1].substring(0, 2).padEnd(2, '0') : "00"
            return '$' + leftOfDecimal + '.' + rightOfDecimal
        },
        formatNumber(number) {
            if (isNaN(number)) return
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        percentDifference(a, b) {
            return Math.round( (((a - b) / b) + Number.EPSILON) * 1000) / 10
        },
        roundNumber(number, precision) {
            if (isNaN(number)) return
            let usePrecision = precision || 100
            return Math.round((number + Number.EPSILON) * usePrecision) / usePrecision
        },
        createLineChart(ref, data, color, hideGrid, hideLabels, valueIsNotCurrency) {
            am5.addLicense("AM5C357185357")
            let root = am5.Root.new(ref)
            let myTheme = am5.Theme.new(root);
            myTheme.rule("AxisLabel").setAll({
                fill: am5.color(0x333333),
                fontSize: "0.6em"
            })
            if (hideGrid) {
                myTheme.rule("Grid").setAll({
                    opacity: 0
                })
            }
            root.setThemes([am5themes_Animated.new(root), myTheme])
            if (valueIsNotCurrency) {
                root.numberFormatter.set("numberFormat", "#,###");
            } else {
                root.numberFormatter.set("numberFormat", "#,###.00");
            }
            root.dateFormatter.setAll({
                dateFormat: "MM/dd/yyyy",
                dateFields: ["valueX"]
            })
            let chart = root.container.children.push(
                am5xy.XYChart.new(root, {})
            )
            chart.set("cursor", am5xy.XYCursor.new(root, {}))
            let yAxis = chart.yAxes.push(
                am5xy.ValueAxis.new(root, {
                    renderer: am5xy.AxisRendererY.new(root, {})
                })
            )
            if (hideLabels) {
                yAxis.get("renderer").labels.template.set("forceHidden", true)
            }

            let xRenderer = am5xy.AxisRendererX.new(root, {
                minGridDistance: 40
            })
            xRenderer.labels.template.setAll({
                paddingTop: 14,
            })
            let xAxis = chart.xAxes.push(
                am5xy.DateAxis.new(root, {
                    baseInterval: { timeUnit: "day", count: 1 },
                    markUnitChange: false,
                    renderer: xRenderer
                })
            )
            if (hideLabels) {
                xAxis.get("renderer").labels.template.set("forceHidden", true)
            }
            xAxis.get("dateFormats")["day"] = "MM/dd"
            let series = chart.series.push(
                am5xy.LineSeries.new(root, {
                    name: "Series",
                    xAxis: xAxis,
                    yAxis: yAxis,
                    valueYField: "value",
                    valueXField: "date",
                    tooltip: am5.Tooltip.new(root, {
                        labelText: (valueIsNotCurrency ? "" : "$") + "{valueY}"
                    })
                })
            )
            // set the graph line width
            series.strokes.template.setAll({ strokeWidth: 2 })
            // set the graph line color
            series.set("stroke", am5.color(color));
            series.data.setAll(data)
            // set the bullet fill color
            series.set("fill", am5.color(color));
            series.bullets.push(function () {
                return am5.Bullet.new(root, {
                    sprite: am5.Circle.new(root, {
                        radius: 3,
                        fill: series.get("fill"),
                        //stroke: root.interfaceColors.get("background"),
                        //strokeWidth: 1
                    })
                })
            })
        },
        createDoubleLineChart(ref, series1Data, series2Data, color, hideGrid, hideLabels) {
            am5.addLicense("AM5C357185357")
            let root = am5.Root.new(ref)
            let myTheme = am5.Theme.new(root);
            myTheme.rule("AxisLabel").setAll({
                fill: am5.color(0x333333),
                fontSize: "0.6em"
            })
            if (hideGrid) {
                myTheme.rule("Grid").setAll({
                    opacity: 0
                })
            }
            root.setThemes([am5themes_Animated.new(root), myTheme])
            root.numberFormatter.set("numberFormat", "#,###.00");
            root.dateFormatter.setAll({
                dateFormat: "MM/dd/yyyy",
                dateFields: ["valueX"]
            })
            let chart = root.container.children.push(
                am5xy.XYChart.new(root, {})
            )
            chart.set("cursor", am5xy.XYCursor.new(root, {}))
            let yAxis = chart.yAxes.push(
                am5xy.ValueAxis.new(root, {
                    renderer: am5xy.AxisRendererY.new(root, {})
                })
            )
            if (hideLabels) {
                yAxis.get("renderer").labels.template.set("forceHidden", true)
            }

            let xRenderer = am5xy.AxisRendererX.new(root, {
                minGridDistance: 40
            })
            xRenderer.labels.template.setAll({
                paddingTop: 14,
            })
            let xAxis = chart.xAxes.push(
                am5xy.DateAxis.new(root, {
                    baseInterval: { timeUnit: "day", count: 1 },
                    markUnitChange: false,
                    renderer: xRenderer
                })
            )
            if (hideLabels) {
                xAxis.get("renderer").labels.template.set("forceHidden", true)
            }
            xAxis.get("dateFormats")["day"] = "MM/dd"
            xRenderer.labels.template.setAll({
                paddingTop: 14,
            })
            let series1 = chart.series.push(
                am5xy.LineSeries.new(root, {
                    name: "Series 1",
                    xAxis: xAxis,
                    yAxis: yAxis,
                    valueYField: "value",
                    valueXField: "date",
                    tooltip: am5.Tooltip.new(root, {
                        labelText: "{compare_label}: ${valueY}"
                    })
                })
            )
            // set the graph line width
            series1.strokes.template.setAll({ strokeWidth: 2 })
            // set the graph line color
            let useColor = ''
            if (Array.isArray(color)) {
                useColor = color[0]
            } else {
                useColor = color
            }
            series1.set("stroke", am5.color(useColor));
            // set the bullet fill color
            series1.set("fill", am5.color(useColor));
            series1.data.setAll(series1Data)
            series1.bullets.push(function () {
                return am5.Bullet.new(root, {
                    sprite: am5.Circle.new(root, {
                        radius: 3,
                        fill: series1.get("fill"),
                        //stroke: root.interfaceColors.get("background"),
                        //strokeWidth: 2
                    })
                })
            })

            let series2 = chart.series.push(
                am5xy.LineSeries.new(root, {
                    name: "Series 2",
                    xAxis: xAxis,
                    yAxis: yAxis,
                    valueYField: "value",
                    valueXField: "date",
                    //categoryField: "compare_label",
                    tooltip: am5.Tooltip.new(root, {
                        labelText: "{compare_label}: ${valueY}"
                    })
                })
            )
            // set the graph line width
            series2.strokes.template.setAll({ strokeWidth: 2 })
            // set the graph line color
            let useColor2 = ''
            if (Array.isArray(color)) {
                useColor2 = color[0]
            } else {
                useColor2 = color
            }
            series1.set("stroke", am5.color(useColor2));
            // set the bullet fill color
            series1.set("fill", am5.color(useColor2));
            series2.data.setAll(series2Data)
            series2.bullets.push(function () {
                return am5.Bullet.new(root, {
                    sprite: am5.Circle.new(root, {
                        radius: 3,
                        fill: series2.get("fill"),
                        //stroke: root.interfaceColors.get("background"),
                        //strokeWidth: 2
                    })
                })
            })

        },
        createBarChart(ref, data, category, value, showBullets) {
            am5.addLicense("AM5C357185357")
            let root = am5.Root.new(ref)
            let myTheme = am5.Theme.new(root);
            myTheme.rule("AxisLabel").setAll({
                fill: am5.color(0x333333),
                fontSize: "0.6em"
            })
            myTheme.rule("Grid").setAll({
                opacity: 0
            })
            root.setThemes([am5themes_Animated.new(root), myTheme])
            root.numberFormatter.set("numberFormat", "#,###.00");
            let chart = root.container.children.push(
                am5xy.XYChart.new(root, {})
            )
            chart.set("cursor", am5xy.XYCursor.new(root, {}))
            let xAxis = chart.xAxes.push(
                am5xy.ValueAxis.new(root, {
                    min: 0, // always start bar chart at zero so lower values still have width
                    renderer: am5xy.AxisRendererX.new(root, {})
                })
            )
            // hide the xAxis labels
            xAxis.get("renderer").labels.template.set("forceHidden", true)
            let yRenderer = am5xy.AxisRendererY.new(root, {
                minGridDistance: 30,
                inversed: true
            })
            yRenderer.labels.template.setAll({
                paddingRight: 12,
            })
            let yAxis = chart.yAxes.push(am5xy.CategoryAxis.new(root, {
                maxDeviation: 0.3,
                categoryField: category,
                renderer: yRenderer
            }))
            yAxis.data.setAll(data);
            let series = chart.series.push(am5xy.ColumnSeries.new(root, {
                name: "Series",
                xAxis: xAxis,
                yAxis: yAxis,
                valueXField: value,
                sequencedInterpolation: true,
                categoryYField: category,
                tooltip: am5.Tooltip.new(root, {
                    labelText: "{categoryY}\n${valueX}"
                })
            }))
            series.columns.template.adapters.add("fill", function(fill, target) {
                return chart.get("colors").getIndex(series.columns.indexOf(target));
            })
            series.columns.template.adapters.add("stroke", function(stroke, target) {
                return chart.get("colors").getIndex(series.columns.indexOf(target));
            })
            if (showBullets) {
                // display xAxis values to the right of bars
                series.bullets.push(function() {
                    return am5.Bullet.new(root, {
                        locationX: 1,
                        locationY: 0.5,
                        sprite: am5.Label.new(root, {
                            centerY: am5.p50,
                            text: "${valueX}",
                            fill: am5.color(0x333333),
                            fontSize: "0.6em",
                            populateText: true
                        })
                    })
                })
            }
            series.data.setAll(data);
        },
        createColumnChart(ref, data, category, value, hideXLabels, hideYLabels, baseColor, valueIsNotCurrency) {
            am5.addLicense("AM5C357185357")
            let root = am5.Root.new(ref)
            let myTheme = am5.Theme.new(root);
            myTheme.rule("AxisLabel").setAll({
                fill: am5.color(0x333333),
                fontSize: "0.6em"
            })
            // hide the grid
            // myTheme.rule("Grid").setAll({
            //     opacity: 0
            // })
            root.setThemes([am5themes_Animated.new(root), myTheme])
            if (valueIsNotCurrency) {
                root.numberFormatter.set("numberFormat", "#,###");
            } else {
                root.numberFormatter.set("numberFormat", "#,###.00");
            }
            let chart = root.container.children.push(
                am5xy.XYChart.new(root, {})
            )
            chart.set("cursor", am5xy.XYCursor.new(root, {}))

            let maxValue = 0
            let dataCount = 0
            for (const [key, item] of Object.entries(data)) {
                maxValue = Math.max(maxValue, item.value)
                dataCount++
            }
            if (baseColor) {
                // generate a pallette of 12 darkened colors based on the baseColor
                let colorPallet = []
                for (let i = 0; i < dataCount * 3; i += 3) {
                    colorPallet.push(am5.color(this.lightenDarkenColor(baseColor, -i)))
                }
                chart.get("colors").set("colors", colorPallet)
            }

            let xRenderer = am5xy.AxisRendererX.new(root, { minGridDistance: 30 });
                xRenderer.labels.template.setAll({
                    rotation: -45,
                    centerY: am5.p50,
                    centerX: am5.p100,
                    paddingRight: 0,
                    paddingTop: 5
            })

            let xAxis = chart.xAxes.push(
                am5xy.CategoryAxis.new(root, {
                    maxDeviation: 0.3,
                    categoryField: category,
                    renderer: xRenderer,
                    //tooltip: am5.Tooltip.new(root, {})
                })
            )
            if (hideXLabels) {
                xAxis.get("renderer").labels.template.set("forceHidden", true)
            }

            let yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
                maxDeviation: 0,
                min: 0,
                max: maxValue,
                strictMinMax: true,
                renderer: am5xy.AxisRendererY.new(root, {})
            }))
            if (hideYLabels) {
                yAxis.get("renderer").labels.template.set("forceHidden", true)
            }
            let series = chart.series.push(am5xy.ColumnSeries.new(root, {
                name: "Series",
                xAxis: xAxis,
                yAxis: yAxis,
                valueYField: value,
                valueXField: category,
                sequencedInterpolation: true,
                categoryXField: category,
                tooltip: am5.Tooltip.new(root, {
                    labelText: hideXLabels ? "{valueX}\n${valueY}" : (valueIsNotCurrency ? "" : "$") + "{valueY}"
                })
            }))
            series.columns.template.adapters.add("fill", function(fill, target) {
                return chart.get("colors").getIndex(series.columns.indexOf(target));
            })
            series.columns.template.adapters.add("stroke", function(stroke, target) {
                return chart.get("colors").getIndex(series.columns.indexOf(target));
            })
            xAxis.data.setAll(data);
            series.data.setAll(data);
        },
        createClusteredColumnChart(ref, data, category, series1, series2, valueIsNotCurrency) {
            am5.addLicense("AM5C357185357")
            let root = am5.Root.new(ref)
            let myTheme = am5.Theme.new(root);
            myTheme.rule("AxisLabel").setAll({
                fill: am5.color(0x333333),
                fontSize: "0.6em"
            })
            myTheme.rule("Grid").setAll({
                opacity: 0
            })
            root.setThemes([am5themes_Animated.new(root), myTheme])
            if (valueIsNotCurrency) {
                root.numberFormatter.set("numberFormat", "#,###");
            } else {
                root.numberFormatter.set("numberFormat", "#,###.00");
            }
            let chart = root.container.children.push(
                am5xy.XYChart.new(root, {})
            )
            chart.set("cursor", am5xy.XYCursor.new(root, {}))

            let xRenderer = am5xy.AxisRendererX.new(root, {
                minGridDistance: 30,
                cellStartLocation: 0.1,
                cellEndLocation: 0.9
            })
            xRenderer.labels.template.setAll({
                rotation: -45,
                centerY: am5.p50,
                centerX: am5.p100
            })
            let xAxis = chart.xAxes.push(
                am5xy.CategoryAxis.new(root, {
                    maxDeviation: 0.3,
                    categoryField: category,
                    renderer: xRenderer,
                    //tooltip: am5.Tooltip.new(root, {})
                })
            )
            xAxis.data.setAll(data);

            let yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
                maxDeviation: 0.3,
                min: 0,
                //strictMinMax: true,
                renderer: am5xy.AxisRendererY.new(root, {})
            }))
            function createSeries(field, name) {
                let series = chart.series.push(am5xy.ColumnSeries.new(root, {
                    name: name,
                    xAxis: xAxis,
                    yAxis: yAxis,
                    valueYField: field,
                    sequencedInterpolation: true,
                    categoryXField: category,
                    tooltip: am5.Tooltip.new(root, {
                        labelText: "{name} " + (valueIsNotCurrency ? "" : "$") + "{valueY}"
                    })
                }))
                series.data.setAll(data);
                series.columns.template.adapters.add("fill", function(fill, target) {
                    return chart.get("colors").getIndex(series.columns.indexOf(target));
                })
                series.columns.template.adapters.add("stroke", function(stroke, target) {
                    return chart.get("colors").getIndex(series.columns.indexOf(target));
                })
                return series
            }

            let seriesA = createSeries(series1.value, series1.name);
            let seriesB = createSeries(series2.value, series2.name);

        },
        createGroupedColumnChart(ref, data, rotateGroupLabels, baseColor, valueIsNotCurrency) {
            am5.addLicense("AM5C357185357")
            let root = am5.Root.new(ref)
            let myTheme = am5.Theme.new(root);
            myTheme.rule("AxisLabel").setAll({
                fill: am5.color(0x333333),
                fontSize: "0.6em"
            })
            // hide the grid
            // myTheme.rule("Grid").setAll({
            //     opacity: 0
            // })
            root.setThemes([am5themes_Animated.new(root), myTheme])
            if (valueIsNotCurrency) {
                root.numberFormatter.set("numberFormat", "#,###");
            } else {
                root.numberFormatter.set("numberFormat", "#,###.00");
            }
            let chart = root.container.children.push(
                am5xy.XYChart.new(root, {})
            )
            chart.set("cursor", am5xy.XYCursor.new(root, {}))

            let maxValue = 0
            let dataCount = 0
            for (const [key, item] of Object.entries(data)) {
                maxValue = Math.max(maxValue, item.value)
                dataCount++
            }

            let xRenderer = am5xy.AxisRendererX.new(root, { minGridDistance: 30 });

            xRenderer.labels.template.setAll({
                text: "{compName}"
            })

            let xAxis = chart.xAxes.push(
                am5xy.CategoryAxis.new(root, {
                    maxDeviation: 0,
                    categoryField: "category",
                    strictMinMax: true,
                    renderer: xRenderer,
                    tooltip: am5.Tooltip.new(root, {
                        labelText: "{provider}"
                    })
                })
            )

            let yAxis = chart.yAxes.push(
                am5xy.ValueAxis.new(root, {
                    maxDeviation: 0.3,
                    min: 0,
                    max: maxValue,
                    strictMinMax: true,
                    renderer: am5xy.AxisRendererY.new(root, {})
                })
            )

            let yAxis2 = chart.yAxes.push(
                am5xy.ValueAxis.new(root, {
                    maxDeviation: 0.3,
                    min: 0,
                    max: maxValue,
                    strictMinMax: true,
                    syncWithAxis: yAxis,
                    renderer: am5xy.AxisRendererY.new(root, {
                        opposite: false // true = display on right side of chart
                    })
                })
            )

            let series = chart.series.push(
                am5xy.ColumnSeries.new(root, {
                    name: "Series 1",
                    xAxis: xAxis,
                    yAxis: yAxis2,
                    valueYField: "value",
                    sequencedInterpolation: true,
                    categoryXField: "category",
                    tooltip: am5.Tooltip.new(root, {
                        labelText: "{realName}: "  + (valueIsNotCurrency ? "" : "$") + "{valueY}"
                    })
                })
            )

            series.columns.template.setAll({
                fillOpacity: 1,
                strokeOpacity: 0
            })

            let comparePalette = []
            console.log(baseColor)
            if (baseColor) {
                if (Array.isArray(baseColor)) {
                    for (let i = 0; i < 45; i++) {
                        comparePalette.push(am5.color(baseColor[1]))
                        comparePalette.push(am5.color(baseColor[0]))
                    }
                } else {
                    for (let i = 0; i < 45; i++) {
                        comparePalette.push(am5.color(baseColor))
                        comparePalette.push(am5.color(this.lightenDarkenColor(baseColor, -40)))
                    }
                }
    
            } else {
                // new palette with every other color a version of the previous
                let originalPalette = this.colorPalette()
                originalPalette.forEach((color, index) => {
                    comparePalette.push(am5.color(color))
                    comparePalette.push(am5.color(this.lightenDarkenColor(color, -30)))
                })
            }

            chart.get("colors").set("colors", comparePalette)

            series.columns.template.adapters.add("fill", (fill, target) => {
                return chart.get("colors").getIndex(series.columns.indexOf(target))
            })

            let chartData = [];

            // process data and prepare it for the chart
            for (var providerName in data) {
                let providerData = data[providerName]
                // add data of one provider to temp array
                let tempArray = [];
                let count = 0;
                // add items
                for (var itemName in providerData) {
                    count++;
                    // we generate unique category for each column (providerName + "_" + itemName) and store realName
                    tempArray.push({
                        category: providerName + "_" + itemName,
                        realName: itemName,
                        compName: dataCount > 20 ? '' : itemName, // comp labels are too crowded if more than 20
                        value: providerData[itemName],
                        provider: providerName
                    })
                }

                // push to the final data
                am5.array.each(tempArray, function (item) {
                   chartData.push(item);
                })

                // create range (the additional label at the bottom)

                let range = xAxis.makeDataItem({})
                xAxis.createAxisRange(range)

                range.set("category", tempArray[0].category)
                range.set("endCategory", tempArray[tempArray.length - 1].category)

                let label = range.get("label")

                if (rotateGroupLabels) {
                    label.setAll({
                        text: tempArray[0].provider,
                        dy: 24,
                        rotation: -45,
                        centerY: am5.p50,
                        centerX: am5.p100,
                        fontWeight: "bold",
                        tooltipText: tempArray[0].provider
                    })
                } else {
                    label.setAll({
                        text: tempArray[0].provider,
                        dy: 24,
                        fontWeight: "bold",
                        tooltipText: tempArray[0].provider
                    })
                }

                let tick = range.get("tick");
                tick.setAll({ visible: true, strokeOpacity: 1, length: 40, location: 0 })

                let grid = range.get("grid");
                grid.setAll({ strokeOpacity: 1 })
            }

            // add range for the last grid
            let range = xAxis.makeDataItem({});
            xAxis.createAxisRange(range);
            range.set("category", chartData[chartData.length - 1].category);
            let tick = range.get("tick");
            tick.setAll({ visible: true, strokeOpacity: 1, length: 50, location: 1 });

            let grid = range.get("grid");
            grid.setAll({ strokeOpacity: 1, location: 1 });

            xAxis.data.setAll(chartData);
            series.data.setAll(chartData);
            //lineSeries.data.setAll(chartData);

        },
        createColumnLineChart(ref, data, category, series1, series2, colorCompareColumn) {
            am5.addLicense("AM5C357185357")
            // colorCompareColumn is the data column used to set line bullets to same color as bars in series
            let root = am5.Root.new(ref)
            let myTheme = am5.Theme.new(root);
            myTheme.rule("AxisLabel").setAll({
                fill: am5.color(0x333333),
                fontSize: "0.6em"
            })
            myTheme.rule("Grid").setAll({
                opacity: 0
            })
            root.setThemes([am5themes_Animated.new(root), myTheme])
            root.numberFormatter.set("numberFormat", "#,###.00");
            let chart = root.container.children.push(
                am5xy.XYChart.new(root, {})
            )
            chart.set("cursor", am5xy.XYCursor.new(root, {}))

            let xRenderer = am5xy.AxisRendererX.new(root, {
                minGridDistance: 15,
                cellStartLocation: 0.1,
                cellEndLocation: 0.9
            })
            xRenderer.labels.template.setAll({
                rotation: -45,
                centerY: am5.p50,
                centerX: am5.p100
            })
            let xAxis = chart.xAxes.push(
                am5xy.CategoryAxis.new(root, {
                    maxDeviation: 0.3,
                    categoryField: category,
                    renderer: xRenderer,
                    //tooltip: am5.Tooltip.new(root, {})
                })
            )
            let yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
                maxDeviation: 0.3,
                renderer: am5xy.AxisRendererY.new(root, {})
            }))
            xAxis.data.setAll(data);
            let chartSeries1 = chart.series.push(am5xy.ColumnSeries.new(root, {
                name: series1.name,
                xAxis: xAxis,
                yAxis: yAxis,
                valueYField: series1.value,
                sequencedInterpolation: true,
                categoryXField: category,
                tooltip: am5.Tooltip.new(root, {
                    labelText: "{name} ${valueY}"
                })
            }))
            chartSeries1.columns.template.adapters.add("fill", function(fill, target) {
                return chart.get("colors").getIndex(chartSeries1.columns.indexOf(target))
            })
            chartSeries1.columns.template.adapters.add("stroke", function(stroke, target) {
                return chart.get("colors").getIndex(chartSeries1.columns.indexOf(target))
            })
            chartSeries1.data.setAll(data)

            let chartSeries2 = chart.series.push(am5xy.LineSeries.new(root, {
                name: series2.name,
                xAxis: xAxis,
                yAxis: yAxis,
                valueYField: series2.value,
                sequencedInterpolation: true,
                categoryXField: category,
                seriesTooltipTarget: "bullet",
                tooltip: am5.Tooltip.new(root, {
                    labelText: "{name} ${valueY}"
                })
            }))
            chartSeries2.strokes.template.setAll({
                strokeWidth: 1,
                opacity: 0
            })
            chartSeries2.data.setAll(data)

            let colorSet = am5.ColorSet.new(root, {})
            function getColorIndex(dataItem, series) {
                let compareId = dataItem.dataContext[colorCompareColumn]
                let index = series._dataItems.findIndex((item) => item.dataContext[colorCompareColumn] == compareId)
                return index
            }
            chartSeries2.bullets.push(function (root, series, dataItem) {
                return am5.Bullet.new(root, {
                    sprite: am5.Circle.new(root, {
                        strokeWidth: 2,
                        stroke: root.interfaceColors.get("background"), // colorSet.getIndex(getColorIndex(dataItem, series)),
                        radius: series._dataItems.length > 10 ? 7 : 12,
                        fill: colorSet.getIndex(getColorIndex(dataItem, series)) // root.interfaceColors.get("background")
                        //fill: root.interfaceColors.get("background")
                    })
                })
            })
        },
        createPieChart(ref, data, category, value, isCurrency, alignLabels, radius) {
            am5.addLicense("AM5C357185357")
            let root = am5.Root.new(ref)
            let myTheme = am5.Theme.new(root);
            myTheme.rule("Label").setAll({
                fill: am5.color(0x333333),
                fontSize: "0.6em"
            })
            root.setThemes([am5themes_Animated.new(root), myTheme])
            if (isCurrency) {
                root.numberFormatter.set("numberFormat", "#,###.00");
            }
            let useRadius = radius || 80
            let chart = root.container.children.push(
                am5percent.PieChart.new(root, {
                    radius: am5.percent(useRadius),
                    innerRadius: am5.percent(40),
                    layout: root.verticalHorizontal
                })
            )
            let series = chart.series.push(am5percent.PieSeries.new(root, {
                name: "Series",
                valueField: value,
                categoryField: category,
                alignLabels: alignLabels, // will keep labels close to ring
                tooltip: am5.Tooltip.new(root, {
                    labelText: "{category}\n{valuePercentTotal.formatNumber('0.0')}%"
                })
            }))
            if (isCurrency) {
                series.labels.template.setAll({
                    text: "{category}\n${value}"
                })
            } else {
                series.labels.template.setAll({
                    text: "{category}\n{value}"
                })
            }
            series.data.setAll(data);
        },
        lightenDarkenColor(colorCode, amount) {
            var usePound = false;
            if (colorCode[0] == "#") {
                colorCode = colorCode.slice(1);
                usePound = true;
            }
            var num = parseInt(colorCode, 16);

            var r = (num >> 16) + amount;
            if (r > 255) {
                r = 255;
            } else if (r < 0) {
                r = 0;
            }
            var b = ((num >> 8) & 0x00FF) + amount;
            if (b > 255) {
                b = 255;
            } else if (b < 0) {
                b = 0;
            }
            var g = (num & 0x0000FF) + amount;
            if (g > 255) {
                g = 255;
            } else if (g < 0) {
                g = 0;
            }
            return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
        },
        colorPalette() {
            return [
                '#57A8D4',
                '#567FD3',
                '#5458D3',
                '#6C4CD3',
                '#924BD4',
                '#B94AD4',
                '#D24AC4',
                '#D24C9B',
                '#D24E75',
                '#D25254',
                '#D37854',
                '#D3A054',
                '#D9D067',
                '#B8D855',
                '#91D854',
                '#6ED954',
                '#91E496',
                '#59D886',
                '#59D7AD',
                '#98E4E5',
                '#81BEDD',
                '#557FD3',
                '#A8AAEA',
                '#6C4CD3'
            ]
        }
    }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
